import url from 'front-end-core/core/url'
import { COMMENTS } from 'constants/controllers'
import FilterContainer from 'redux/containers/pages/comments/FilterContainer'
import React from 'react'
import onClickOutside from 'react-onclickoutside'

const ContentPreviewsFilter = ({ category, order, users, privacy, archived, preview, aol, ...props }) => {
  const link = preview => url(
    COMMENTS,
    { aol },
    { category, order, users, privacy, archived, preview }
  )

  ContentPreviewsFilter.handleClickOutside = () => {
    props.setExpanded(false)
  }

  return (
    <FilterContainer
      title='Show content previews:'
      link={link}
      value={preview}
      options={[
        { name: 'Yes', value: 'show' },
        { name: 'No', value: 'hide' }
      ]}
      {...props}
    />
  )
}

const clickOutsideConfig = {
  handleClickOutside: () => ContentPreviewsFilter.handleClickOutside
}

export default onClickOutside(ContentPreviewsFilter, clickOutsideConfig)
